<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-6 offset-md-3 offset-md-3 mt-5">
                <app-card :title="$t('Log in')">
                    <div v-if="errors.length" class="alert alert-danger">
                        <template v-for="error in errors">{{ $t(error) }}</template>
                    </div>
                    <validation-observer v-slot="{ validate }" slim>
                        <form @submit.prevent="login(validate)">
                            <app-input id="email" v-model="form.email" name="email" rules="required|email" type="email">
                                <template #label>
                                    {{ $t('Email') }}*
                                </template>
                            </app-input>

                            <app-input id="password" v-model="form.password" name="password" rules="required" type="password">
                                <template #label>
                                    {{ $t('Password') }}*
                                </template>
                            </app-input>

                            <app-button :loading="loading" small>
                                {{ $t('Log in') }}
                            </app-button>
                            <!--                            <router-link to="/auth/register" class="btn btn-outline-info btn-sm ml-2" exact>-->
                            <!--                                {{ $t('Register') }}-->
                            <!--                            </router-link>-->
                            <router-link :to="{name: 'password.request'}" class="btn btn-outline-success btn-sm ml-2" exact>
                                {{ $t('Forgot password') }}
                            </router-link>
                            <router-link to="/" class="btn btn-outline-success btn-sm ml-2" exact>
                                {{ $t('Public') }}
                            </router-link>
                        </form>
                    </validation-observer>
                </app-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            status: '',
            form: {
                email: '',
                password: '',
            },
            loading: false,
            errors: []
        };
    },
    methods: {
        login(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    this.$store.dispatch('LOGIN', this.form).then(res => {
                    }).catch(err => {
                        this.loading = false;
                        Object.keys(err.response.data.errors).forEach(key => {
                            this.errors = err.response.data.errors[key];
                        });
                    });
                }
            });
        }
    },
};
</script>
